import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./Sync.css";
import { Offline, Online } from "react-detect-offline";
import offline from "../../assets/images/offline.png";
import syncButton from "../../assets/images/syncButton.svg";
import syncCompleted from "../../assets/images/syncCompleted.svg";

function Sync(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSyncActivated, setIsSyncActivated] = useState(false);
  const [isSyncCompleted, setIsSyncCompleted] = useState(false);

  useEffect(() => {
    props.setTab("sync");
  }, [props]);

  return (
    <div className="outer-body">
      <Online>
        <Button
          className="sync-button"
          onClick={() => {
            setIsSyncActivated(true);
            setTimeout(
              function () {
                setIsSyncCompleted(true);
                // setIsSyncActivated(false);
              }.bind(this),
              5000,
            );
          }}
          variant="primary"
        >
          {isSyncActivated ? (
            isSyncCompleted ? (
              <img src={syncCompleted} alt={"sync-icon"} />
            ) : (
              <img src={syncButton} className="sync-icon" alt={"sync-icon"} />
            )
          ) : (
            t("sync.label")
          )}
        </Button>
      </Online>

      <Offline>
        <img
          src={offline}
          className="sync-button"
          alt={"offline-icon"}
          style={{ margin: "auto" }}
        />
        {t("offline.label")}
      </Offline>
    </div>
  );
}

export default Sync;
